import httpService from "../../Service/httpService";

const controller = "Catalogos";

export const getAcceso = async (idNegocio, idUser, idModulo) => {
	const res = await httpService.get(`/${controller}/getAcceso/${idNegocio}/${idUser}/${idModulo}`);
	return res.data;
}

export const getNaciones = async () => {
	const res = await httpService.get(`/${controller}/getNaciones`);
	return res.data;
}

export const getEntidades = async () => {
	const res = await httpService.get(`/${controller}/getEstados`);
	return res.data;
}

export const getMunicipios = async (idEntidad) => {
	const res = await httpService.get(`/${controller}/getMunicipios/${idEntidad}`);
	return res.data;
}

export const getFormaciones = async () => {
	const res = await httpService.get(`/${controller}/getFormaciones`);
	return res.data;
}

export const getReligiones = async () => {
	const res = await httpService.get(`/${controller}/getReligiones`);
	return res.data;
}

export const getCatInsumos = async (id) => {
	const res = await httpService.get(`/${controller}/getCatInsumos/${id}`);
	return res.data;
}

export const getRequisitos = async (id) => {
	const res = await httpService.get(`/${controller}/getRequisitos/${id}`);
	return res.data;
}

export const getDocsEntregados = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getDocsEntregados/${id}/${idPac}`);
	return res.data;
}

export const getMedicos = async (id) => {
	const res = await httpService.get(`/${controller}/getMedicos/${id}`);
	return res.data;
}

export const getMedicosServicio = async (id, idServicio, idMedicoSesion) => {
	const res = await httpService.get(`/${controller}/getMedicosServicio/${id}/${idServicio}/${idMedicoSesion}`);
	return res.data;
}

export const getListEnfermeras = async (id) => {
	const res = await httpService.get(`/${controller}/getListEnfermeras/${id}`);
	return res.data;
}

export const getListaMedicos = async (id) => {
	const res = await httpService.get(`/${controller}/getListaMedicos/${id}`);
	return res.data;
}

export const getListaMaquinas = async (id) => {
	const res = await httpService.get(`/${controller}/getListaMaquinas/${id}`);
	return res.data;
}

export const getListaInsumos = async (id) => {
	const res = await httpService.get(`/${controller}/getListaInsumos/${id}`);
	return res.data;
};

export const getListaTecnicos = async (id) => {
	const res = await httpService.get(`/${controller}/getListaTecnicos/${id}`);
	return res.data;
}

export const getListServicios = async (id) => {
	const res = await httpService.get(`/${controller}/getListServicios/${id}`);
	return res.data;
}

export const getListPreciosInsumos = async (id) => {
	const res = await httpService.get(`/${controller}/getListPrecios/${id}`);
	return res.data;
}

export const getListTipoDocs = async (id) => {
	const res = await httpService.get(`/${controller}/getListTipoDocs/${id}`);
	return res.data;
}

export const getPerfiles = async (id, perfil) => {
	const res = await httpService.get(`/${controller}/getPerfiles/${id}/${perfil}`);
	return res.data;
}

export const getDatosPerfil = async (id, perfil, idPerfil) => {
	const res = await httpService.get(`/${controller}/getDatosPerfil/${id}/${perfil}/${idPerfil}`);
	return res.data;
}

export const getCatUsers = async (id, idUser) => {
	const res = await httpService.get(`/${controller}/getCatUsers/${id}/${idUser}`);
	return res.data;
}

export const getModulosAsignados = async (id, idUser) => {
	const res = await httpService.get(`/${controller}/getModulosAsignados/${id}/${idUser}`);
	return res.data;
}

export const getModulosSys = async (id) => {
	const res = await httpService.get(`/${controller}/getModulos/${id}`);
	return res.data;
}

export const getListaUsers = async (id, idUser) => {
	const res = await httpService.get(`/${controller}/getListaUsers/${id}/${idUser}`);
	return res.data;
}

export const getCatDiagnosticos = async (filtro) => {
	const res = await httpService.get(`/${controller}/getCatDiagnosticos/${filtro}`);
	return res.data;
}

export const getGruposLab = async (id) => {
	const res = await httpService.get(`/${controller}/getGruposLab/${id}`);
	return res.data;
}

export const getMarcadoresLab = async (id, idGpo) => {
	const res = await httpService.get(`/${controller}/getMarcadoresLab/${id}/${idGpo}`);
	return res.data;
}

export const getListMarcadoresLab = async (id) => {
	const res = await httpService.get(`/${controller}/getListMarcadoresLab/${id}`);
	return res.data;
}

export const saveUser = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveUser`, {
		...data,
	});
	return res;
};

export const savePermisoUser = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/savePermisoUser`, {
		...data,
	});
	return res;
};

export const saveGrupoLab = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveGrupoLab`, {
		...data,
	});
	return res;
};

export const saveMarcadorLab = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveMarcadorLab`, {
		...data,
	});
	return res;
};


export const deletePermiso = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/deletePermiso`, {
		...data,
	});
	return res;
};

export const updateServicio = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/updateServicio`, {
		...data,
	});
	return res;
};

export const updatePrecioInsumo = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/updatePrecioInsumo`, {
		...data,
	});
	return res;
};

export const saveMaquina = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveMaquina`, {
		...data,
	});
	return res;
};

export const saveEnfermera = async (formData) => {
	try {
		const response = await httpService.post(`/${controller}/saveEnfermera`, formData, {
			headers: {
				// Axios automatically sets the correct Content-Type for FormData,
				// but explicitly setting it to multipart/form-data can also work
				'Content-Type': 'multipart/form-data',
			},
		});
		console.log('File upload successful:', response.data);
		return response.data;
	} catch (error) {
		console.error('Error uploading file:', error);
		throw error;
	}
};


export const saveMedico = async (formData) => {
	try {
		const response = await httpService.post(`/${controller}/saveMedico`, formData, {
			headers: {
				// Axios automatically sets the correct Content-Type for FormData,
				// but explicitly setting it to multipart/form-data can also work
				'Content-Type': 'multipart/form-data',
			},
		});
		console.log('File upload successful:', response.data);
		return response.data;
	} catch (error) {
		console.error('Error uploading file:', error);
		throw error;
	}
};


export const saveTecnico = async (formData) => {
	try {
		const response = await httpService.post(`/${controller}/saveTecnico`, formData, {
			headers: {
				// Axios automatically sets the correct Content-Type for FormData,
				// but explicitly setting it to multipart/form-data can also work
				'Content-Type': 'multipart/form-data',
			},
		});
		console.log('File upload successful:', response.data);
		return response.data;
	} catch (error) {
		console.error('Error uploading file:', error);
		throw error;
	}
};






